var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDoorDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dc8758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c3d27"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.819,
    x2: 523.538,
    xlinkHref: "#lg1",
    y1: 120.964,
    y2: 548.683
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.638,
    x2: 41.014,
    xlinkHref: "#lg1",
    y1: 276.362,
    y2: 3.738
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 287.93,
    x2: 68.881,
    xlinkHref: "#lg1",
    y1: 429.07,
    y2: 210.021
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#904d24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c3d27"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.855,
    x2: 224.855,
    xlinkHref: "#lg2",
    y1: 343.546,
    y2: 454.551
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaf6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2575,
    stopColor: "#dce8fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7423,
    stopColor: "#b8c4ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2aee6"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 429.854,
    y2: 467.867
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 474.614,
    y2: 501.53
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.012,
    x2: 63.609,
    xlinkHref: "#lg2",
    y1: 305.988,
    y2: 127.585
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.331,
    x2: 172.272,
    xlinkHref: "#lg3",
    y1: 187.307,
    y2: 236.249
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.519,
    x2: 145.519,
    y1: 217.46,
    y2: 244.769
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8795de",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4678,
    stopColor: "#7d8ddc",
    stopOpacity: 0.468
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c7fd8"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 265.204,
    x2: 464.597,
    y1: 240.419,
    y2: 439.812
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fee45a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe860a"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe860a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7701"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 456.08,
    x2: 198.986,
    xlinkHref: "#lg4",
    y1: 327.818,
    y2: 145.159
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 481.301,
    x2: 323.994,
    xlinkHref: "#lg4",
    y1: 272.206,
    y2: 438.108
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.126,
    x2: 348.126,
    xlinkHref: "#lg4",
    y1: 393.658,
    y2: 438.807
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.276,
    x2: 359.31,
    xlinkHref: "#lg3",
    y1: 223.341,
    y2: 294.374
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m374 465.739v-431.478c0-18.922-15.339-34.261-34.261-34.261h-229.767c-18.922 0-34.262 15.339-34.262 34.261v431.477c0 18.923 15.34 34.262 34.262 34.262h229.767c18.922 0 34.261-15.339 34.261-34.261z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m341.875 279.973v-186.852c0-5.049-4.151-9.157-9.197-8.996-11.057.354-22.227-3.685-30.668-12.125-3.383-3.384-6.06-7.206-8.031-11.283-12.931-26.758-39.375-44.338-69.094-44.338h-.067c-29.718 0-56.157 17.583-69.089 44.34-1.97 4.077-4.647 7.898-8.03 11.281-8.44 8.44-19.61 12.479-30.668 12.125-5.046-.161-9.197 3.947-9.197 8.996v186.852c0 7.747 6.28 14.027 14.027 14.027h205.985c7.749 0 14.029-6.28 14.029-14.027z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341.88 333.027v65.945c0 7.747-6.28 14.027-14.027 14.027h-205.986c-7.747 0-14.027-6.28-14.027-14.027v-65.945c0-7.747 6.28-14.027 14.027-14.027h205.985c7.748 0 14.028 6.28 14.028 14.027z",
    fill: "url(#SVGID_3_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m75.71 321.047v143.286c0 19.698 14.735 35.667 32.912 35.667h232.466c18.177 0 32.912-15.968 32.912-35.667v-143.286z",
    fill: "url(#SVGID_4_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m456.6 469.254h-403.2c-9.058 0-16.4-7.343-16.4-16.4v-7.537c0-9.058 7.343-16.4 16.4-16.4h403.2c9.058 0 16.4 7.343 16.4 16.4v7.537c0 9.058-7.343 16.4-16.4 16.4z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m490.816 510h-471.632c-10.595 0-19.184-8.589-19.184-19.184v-10.816c0-10.595 8.589-19.184 19.184-19.184h471.633c10.595 0 19.184 8.589 19.184 19.184v10.816c-.001 10.595-8.59 19.184-19.185 19.184z",
    fill: "url(#SVGID_6_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m171.757 192.329c-5.648-7.832-14.844-12.936-25.238-12.936-17.177 0-31.102 13.925-31.102 31.102 0 10.394 5.103 19.59 12.936 25.238l243.064 243.064c1.661-4.025 2.583-8.433 2.583-13.058v-71.166z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 145.519,
    cy: 209.495,
    fill: "url(#SVGID_8_)",
    r: 31.102
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.427 209.875c.204 17.001 14.042 30.723 31.092 30.723s30.888-13.721 31.092-30.723z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m463.606 428.917h-230.96c-5.188 0-9.394-4.206-9.394-9.394v-192.364c0-5.188 4.206-9.394 9.394-9.394h230.96c5.188 0 9.394 4.206 9.394 9.394v192.363c0 5.189-4.206 9.395-9.394 9.395z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m473 227.159v192.365c0 5.186-4.207 9.393-9.392 9.393h-30.655l-151.304-151.304v-59.847h181.959c5.185 0 9.392 4.207 9.392 9.393z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m463.606 217.765h-65.62c5.188 0 9.394 4.206 9.394 9.394v192.363c0 5.188-4.206 9.394-9.394 9.394h65.62c5.188 0 9.394-4.206 9.394-9.394v-192.363c0-5.188-4.206-9.394-9.394-9.394z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.252 377.988v41.535c0 5.188 4.206 9.394 9.394 9.394h230.96c5.188 0 9.394-4.206 9.394-9.394v-41.535z",
    fill: "url(#SVGID_13_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m291.291 279.222.184.112c4.223 2.564 9.532 2.521 13.712-.112 4.272-2.58 9.622-2.58 13.895 0 4.272 2.58 9.622 2.58 13.895 0h.001c1.98-1.146 4.171-1.171 6.377-.757 2.517.472 4.854-1.415 4.854-3.975v-54.814c0-1.825-1.48-3.305-3.305-3.305h-57.541c-1.825 0-3.305 1.48-3.305 3.305v54.736c0 2.545 2.315 4.451 4.816 3.982 2.228-.418 4.439-.373 6.417.828z",
    fill: "url(#SVGID_14_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoorDelivery);
export default __webpack_public_path__ + "static/media/icon-door-delivery.df4c55560e33148eceb3e4ccc8595d37.svg";
export { ForwardRef as ReactComponent };